/*
 * @Author: sillyy
 * @Date: 2019-02-11 11:15:09
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-12-10 16:36:35
 * @Description: 登录API
 */
import request from '@/utils/request';
import util from '@/utils';

import { OForm } from '@/types/views/login';

/**
 * 登录
 * @param {OForm} params 参数
 */
export function login(params: OForm) {
  const { username, password, captcha } = params;
  const data = {
    accountName: username,
    accountPassword: util.encodePwd(password),
    captcha
  };

  // return request('/account/login', data);
  return request('/account/orgLogin', data);
}

/**
 * 分校自动登录
 * @param {OForm} params 参数
 */
export function branchLogin(params: OForm): any {
  return request('/branch/branchLogin', params, 'POST');
}

/**
 * 获取当前用户信息
 */
export function getUserInfo() {
  return request('/account/getCurrentAccount');
}

/**
 * 退出账号
 */
export function quit() {
  return request('/account/logout');
}

/**
 * @description: 获取分校账号-用于B端分校视角
 * @param {any} options 参数
 */
export function branchMode(options: any): any {
  return request('/branch/branchMode', options, 'post');
}

/**
 * @description: 更改密码
 * @param {any} options 参数
 */
export function updatePwd(options: any) {
  const data = {
    accountId: options.id,
    oldPassword: util.encodePwd(options.oldPwd),
    newPassword: util.encodePwd(options.newPwd),
    captcha: options.captcha
  };
  return request('/account/updatePWD', data, 'post');
}
